import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { UserTrackingService } from "./user-tracking.service";
import { ClickEvent } from "@common";

@Injectable({
  providedIn: 'root'
})
export class HeatmapService {
  private enabled = new BehaviorSubject<boolean>(false);
  isEnabled = this.enabled.asObservable();

  private rawClicks = new BehaviorSubject<ClickEvent[]>([]);
  clickEvents$ = this.rawClicks.asObservable();

  constructor(
    private readonly userTrackingService: UserTrackingService,
    router: Router
  ) {
    router.events
      .subscribe(event => {
        if (this.enabled.value && event instanceof NavigationEnd) {
          this.userTrackingService.getEvents("click", { url: event.urlAfterRedirects }).subscribe({
            next: (newEvents) => this.rawClicks.next(newEvents)
          });
        }
      })
  }

  toggleOverlay(): void {
    this.enabled.next(!this.enabled.value)
  }

}